"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[97881],{

/***/ 97881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var global_LandingPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55781);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23443);



function PriceAlert() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_LandingPage__WEBPACK_IMPORTED_MODULE_1__/* .PageHeader */ .mr, {
                title: "Price Alert",
                description: "Dapatkan notifikasi real-time ketika harga saham kamu tercapai"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_LandingPage__WEBPACK_IMPORTED_MODULE_1__/* .SectionBrowser */ .Dr, {
                title: "Real-Time Notification",
                image: "".concat(_constants__WEBPACK_IMPORTED_MODULE_2__/* .ASSET_URL */ .Z, "Price_Alert_Blue.jpg"),
                description: "Notifikasi yang dikirimkan secara real-time, sehingga tidak akan ketinggalan momentum. Dapatkan juga di smartphonemu dalam bentuk push notification.",
                reverse: true
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (PriceAlert);


/***/ })

}]);